// extracted by mini-css-extract-plugin
export default {"rootWrapper":"WidgetManager_rootWrapper__w8-Ok","widgetHolder":"WidgetManager_widgetHolder__mnFrG"};